import { HeroSection } from './components/HeroSection';
import { CompanyOverview } from './components/CompanyOverview';
import { StatisticsSection } from './components/StatisticsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FeaturedJobsSection } from './components/FeaturedJobsSection';
import { GoogleIntegrationSection } from './components/GoogleIntegrationSection';
import { useViewport } from '../../hooks/useViewport';
import { useSEO, SEO_CONFIGS } from '../../hooks/useSEO';

export function HomePage() {
  const { isMobile, prefersReducedMotion } = useViewport();
  useSEO(SEO_CONFIGS.home);

  // Enable scroll snapping on mobile only, and respect reduced motion
  const snapClasses = isMobile && !prefersReducedMotion 
    ? 'snap-y snap-mandatory' 
    : '';

  return (
    <div className={`min-h-screen ${snapClasses}`}>
      <section className={isMobile ? 'snap-start snap-always' : ''}>
        <HeroSection />
      </section>
      <section className={isMobile ? 'snap-start' : ''}>
        <CompanyOverview />
      </section>
      <section className={isMobile ? 'snap-start' : ''}>
        <StatisticsSection />
      </section>
      <section className={isMobile ? 'snap-start' : ''}>
        <FeaturedJobsSection />
      </section>
      <section className={isMobile ? 'snap-start' : ''}>
        <GoogleIntegrationSection />
      </section>
      <section className={isMobile ? 'snap-start' : ''}>
        <TestimonialsSection />
      </section>
    </div>
  );
}